import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useState } from 'react'
import {
    Body,
    ButtonAction,
    ButtonsContainer,
    FormComponent,
    dialogPanel,
    dialogTitle,
    textAreaStyles
} from './styles'
import { InputSelect } from 'components/InputSelect'
import { SubmitHandler, useForm } from 'react-hook-form'
import { IoCloseSharp } from 'react-icons/io5'
import { LabelsForInput } from 'components/LabelsForInputs'
import { TextArea } from 'components/TextArea'
import NotificationService from 'services/Notification'
import { NotificationReducer } from 'types/notification'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { VariableReducer } from 'types/variable'
import { getVarible } from 'utils/variblesHandler'
import { IAuthenticationReducer } from 'types/autentication'
import { notificationStatus } from 'constants/notificationStatus'
import moment from 'moment'
import { inputRequiredStyle } from 'components/Datepicker/styles'

interface ArchiveNotificationModalProps {
    handleCloseModal: () => void
    isOpen: boolean
    submitArchive: () => void
}
interface FormData {
    filingReason: any
    observation: string

}

const ArchiveNotificationModal: React.FC<ArchiveNotificationModalProps> = ({
    handleCloseModal,
    isOpen,
    submitArchive
}) => {
    const [reasoneSelect, setReasoneSelect] = useState([])
    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const variableSelector: VariableReducer = useSelector(
        (state: RootReducerState) => state.variableReducers
    )
    const auth: IAuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    useEffect(() => {
        if (variableSelector.variablesList) {
            const varible = getVarible(
                variableSelector.variablesList,
                'containerType',
                'container'
            )
            if (varible?.children) {
                const list = getVarible(
                    varible?.children,
                    'name',
                    'u_reason_for_archiving'
                )
                setReasoneSelect(list?.choices)
            }
        }
    }, [variableSelector])
    const {
        control,
        register,
        watch,
        handleSubmit,
        formState: { errors }
    } = useForm<FormData>()
    const submitForum: SubmitHandler<FormData> = async (data) => {
        const currentDateTime = moment();
        const formattedDateTime = currentDateTime.format('YYYY-MM-DD HH:mm:ss');
        NotificationService.archiveNotification(
            notificationSelector.notificationById?.sys_id.value,
            {
                u_date_and_hour_notification_closed: formattedDateTime,
                u_reason_for_archiving: data?.filingReason,
                u_archiving_observations: data?.observation,
                u_assigned_to: auth?.dataJwt?.sys_id,
                u_state: notificationStatus[5]?.value
            }
        )
            .then((response: any) => {
                submitArchive()
                handleCloseModal()
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const selectedFilingReason = watch('filingReason')
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-ArchiveNotificationModal"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <Dialog.Title
                                        as="h3"
                                        className={dialogTitle}
                                    >
                                        <p className="text-blueTheme text-xl font-semibold">
                                            Arquivar Notificação
                                        </p>
                                        <IoCloseSharp
                                            onClick={handleCloseModal}
                                            className="text-blueTheme h-8 w-8 p-1 cursor-pointer"
                                        />
                                    </Dialog.Title>
                                    <Body>
                                        <p className="text-xs">
                                            Preencha os dados abaixo para
                                            arquivar a notificação. Essa ação
                                            não poderá ser desfeita.
                                        </p>
                                        <form
                                            onSubmit={handleSubmit(submitForum)}
                                        >
                                            <FormComponent className="mt-8">
                                                <InputSelect
                                                    placeholder="Selecionar"
                                                    required={true}
                                                    styleBoxOptions="mt-3.5"
                                                    label="Motivo do arquivamento"
                                                    name="filingReason"
                                                    control={control}
                                                    searchPlaceHolder="Buscar"
                                                    data={
                                                        reasoneSelect?.length
                                                            ? reasoneSelect?.slice(1)
                                                            : []
                                                    }
                                                    defaultValue={''}
                                                    errorStyle={`${errors.filingReason
                                                            ? inputRequiredStyle
                                                            : ''
                                                        }`}
                                                />
                                                <div className="mt-4">
                                                    <LabelsForInput
                                                        title="Observação"
                                                        subtitle="Conte em detalhes o porquê a notificação será arquivada"
                                                    />
                                                    <TextArea
                                                        defaultValue={''}
                                                        name="observation"
                                                        register={register}
                                                        className={
                                                            textAreaStyles
                                                        }
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                        {...(selectedFilingReason ===
                                                            'others' && {
                                                            required: true
                                                        })}
                                                        {...(selectedFilingReason ===
                                                            'others' &&
                                                            errors?.observation && {
                                                            error: {
                                                                message:
                                                                    'Preenchimento obrigatório.'
                                                            }
                                                        })}
                                                    />
                                                </div>
                                            </FormComponent>
                                            <ButtonsContainer>
                                                <ButtonAction
                                                    onClick={() => {
                                                        handleCloseModal()
                                                    }}
                                                    type="button"
                                                    className="text-blueTheme text-sm"
                                                >
                                                    Cancelar
                                                </ButtonAction>

                                                <ButtonAction
                                                    type="submit"
                                                    className="bg-blueTheme text-white text-sm"
                                                >
                                                    Arquivar notificação
                                                </ButtonAction>
                                            </ButtonsContainer>
                                        </form>
                                    </Body>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { ArchiveNotificationModal }
